import React from 'react';
import { ClbButtonIcon } from '@celebration/design-system/dist/lib/button-icon';
import { createComponent } from '@lit-labs/react';

export default createComponent({
    react: React,
    elementClass: ClbButtonIcon,
    tagName: ClbButtonIcon.tagName,
    events: ClbButtonIcon.events,
});
